import { UseUserIdsType } from '../zustand/types';
import useUserStore from '../zustand/userStore';

const useUserIds = (): UseUserIdsType => {
  const userId = useUserStore((state) => state.userId);
  const setUserId = useUserStore((state) => state.setUserId);
  const quizId = useUserStore((state) => state.quizId);
  const setQuizId = useUserStore((state) => state.setQuizId);
  const userCountry = useUserStore((state) => state.userCountry);
  const setUserCountry = useUserStore((state) => state.setUserCountry);
  const userEmail = useUserStore((state) => state.userEmail);
  const setUserEmail = useUserStore((state) => state.setUserEmail);
  const recommendedCourseId = useUserStore(
    (state) => state.recommendedCourseId,
  );
  const setRecommendedCourseId = useUserStore(
    (state) => state.setRecommendedCourseId,
  );

  return {
    ids: { userId, quizId, userCountry, userEmail, recommendedCourseId },
    actions: {
      setUserId,
      setQuizId,
      setUserCountry,
      setUserEmail,
      setRecommendedCourseId,
    },
  };
};

export default useUserIds;
